import { render } from "./PaymentVerification.vue?vue&type=template&id=3b286384&scoped=true"
import script from "./PaymentVerification.vue?vue&type=script&lang=js"
export * from "./PaymentVerification.vue?vue&type=script&lang=js"

import "./PaymentVerification.vue?vue&type=style&index=0&id=3b286384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b286384"]])

export default __exports__